import { isProduction } from '@masfront/common-core'
import { history } from '@masfront/common-csr'
import featureFlags, {
  ReactRouterDOMSource,
  CookiesSource,
  ConfigCatSource,
} from '@masfront/common-feature-flags'
import i18n, { BrowserStrategy } from '@masfront/common-i18n'
import * as configCat from 'configcat-js'

import translations from '../../../translations.json'
import AppDeps from '../model/AppDeps'

import AuthService from '~/auth/services/auth.service'
import { BalanceService } from '~/balance/services/balance.service'
import { BarringService } from '~/barrings/services/barring.service'
import BonusService from '~/bonus/services/bonus.service'
import BuildtimeConfig from '~/config/model/BuildtimeConfig'
import RuntimeConfig from '~/config/model/RuntimeConfig'
import { ConsumptionService } from '~/consumptions/services/consumption.service'
import CustomerService from '~/customer/services/customer.service'
import { DiscountService } from '~/discounts/services/discount.service'
import EnergyContractService from '~/energyContract/services/energyContract.service'
import DownloadContractService from '~/offersConfigurator/services/downloadContract.service'
import { PermissionsService } from '~/permissions/services/permissions.service'
import { ServiceService } from '~/services/services/service.service'
import { SubscriptionDetailService } from '~/subscriptionDetail/services/subscriptionDetail.service'

export default class AppDepsBuilder {
  constructor(private buildtimeConfig: BuildtimeConfig, private runtimeConfig: RuntimeConfig) {}

  buildI18n() {
    i18n.init({
      strategy: new BrowserStrategy({ root: window }),
      supportedLocales: this.runtimeConfig.supportedLocales,
      defaultLocale: this.runtimeConfig.defaultLocale,
      translations,
    })
    return i18n
  }

  buildFeatureFlagsService() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis as any
    const reactRouterDOMSource = new ReactRouterDOMSource(global, history)
    const cookiesSource = new CookiesSource(global)

    const configCatSource = new ConfigCatSource({
      configCat,
      isClient: true,
      options: {
        SDKKey: this.runtimeConfig.configCatSDKKey,
        defaultFlags: {},
      },
    })

    featureFlags.init({
      defaultFeatureFlags: this.runtimeConfig.defaultFeatureFlags,
      debug: !isProduction(this.runtimeConfig.environment),
    })

    featureFlags.initSource('QUERY_PARAMS', reactRouterDOMSource)
    featureFlags.initSource('COOKIES', cookiesSource)
    featureFlags.initSource('REMOTE_FLAGGER', configCatSource)
    return featureFlags
  }

  public buildAppDeps(): AppDeps {
    return {
      authService: new AuthService(
        this.runtimeConfig.authn.apiGateway,
        this.runtimeConfig.authn.clientId,
        'masmovil',
      ),
      balanceService: new BalanceService(this.runtimeConfig.apiGateway),
      barringService: new BarringService(this.runtimeConfig.apiGateway),
      consumptionService: new ConsumptionService(this.runtimeConfig.apiGateway),
      customerService: new CustomerService(this.runtimeConfig.apiGateway),
      buildtimeConfig: this.buildtimeConfig,
      discountService: new DiscountService(this.runtimeConfig.apiGateway),
      downloadContractService: new DownloadContractService(this.runtimeConfig.apiGateway),
      energyContractService: new EnergyContractService(this.runtimeConfig.apiGateway),
      featureFlagsService: this.buildFeatureFlagsService(),
      i18n: this.buildI18n(),
      permissionsService: new PermissionsService(this.runtimeConfig.apiGateway),
      runtimeConfig: this.runtimeConfig,
      serviceService: new ServiceService(this.runtimeConfig.apiGateway),
      bonusService: new BonusService(this.runtimeConfig.apiGateway),
      subscriptionDetailService: new SubscriptionDetailService(this.runtimeConfig.apiGateway),
    }
  }
}
